import { TActions } from '../../../AppModulesWrapper';

import { IWebviewState } from '../../types/reducers/webview';

import { defaultState } from './defaultState';

export const webview = (state: IWebviewState = defaultState, action: TActions): IWebviewState => {
  switch (action.type) {
    default:
      return state;
  }
};
